import { render, staticRenderFns } from "./stellar.vue?vue&type=template&id=f15e55b4&"
import script from "./stellar.vue?vue&type=script&lang=ts&"
export * from "./stellar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports